/* eslint-disable no-unused-vars */
import { headerConfig, tokenConfig } from './helperFunc';
import axios from 'axios';
const config = headerConfig();

// machines log reducer actions

export const localhost = window.location.href.includes('localhost');

//export const urlPicker = 'https://core.thelaundro.com';

export const urlPicker =
	window.location.href.includes('da.thelaundro') ||
		window.location.href.includes('sandbox.thelaundro') ||
		window.location.href.includes('sb.')
		? 'https://core-report-sb.thelaundro.com'
		: window.location.href.includes('sandbox.antlysis')
			? 'https://core-report-sb.thelaundro.com'
			: window.location.href.includes('octopus')
				? 'https://octopus-core-report.thelaundro.com'
				: window.location.href.includes('qrpayjomcuci')
					? 'https://octopus-core-report.thelaundro.com'
					: 'https://core-report.thelaundro.com';

export const checkDoPaymentUrl = localhost ? '/get/opid' : `${urlPicker}/get/opid`;

// ********************************* MACHINE LOGS  *********************************
// /api/distributor/v1/operator/fetch
const machineRoot = localhost ? '/api/logging/v1' : `${urlPicker}/api/logging/v1`;
const external = localhost ? '/api/distributor/v1/operator' : `${urlPicker}/api/distributor/v1/operator`;

export const fetchOperatorsAction = (distributorToken) => axios.get(`${external}/fetch`, tokenConfig(distributorToken));

export const machinesLogsAction = (operatorId, token) =>
	axios.get(`${machineRoot}/fetch?operatorId=${operatorId}`, tokenConfig(token));

export const addMachineLogAction = (formData, token) =>
	axios.post(`${machineRoot}/create`, formData, tokenConfig(token));

export const updateMachineLogAction = (formData, token) =>
	axios.put(`${machineRoot}/edit`, formData, tokenConfig(token));

// ********************************* MACHINE utilization  *********************************
const warrantyLink = localhost
	? '/api/maintenance-warranty/v1/machine/warranty'
	: `${urlPicker}/api/maintenance-warranty/v1/machine/warranty`;

export const addWarrantyAction = (formData, token) => axios.post(`${warrantyLink}/add`, formData, tokenConfig(token));

// machineUtilReducer reducer actions
const machineUtilRoot = localhost ? '/api/report/utilization/v1' : `${urlPicker}/api/report/utilization/v1`;

export const annualUtilReportAction = (reqBody, token) =>
	axios.post(`${machineUtilRoot}/annual`, reqBody, tokenConfig(token));

export const monthlyUtilReportAction = (reqBody, token) =>
	axios.post(`${machineUtilRoot}/monthly`, reqBody, tokenConfig(token));

export const outletDailyUtilAction = (year, month, outletId, operatorId, token) =>
	axios.get(
		`${machineUtilRoot}/daily?year=${year}&month=${month}&outletId=${outletId}&operatorId=${operatorId}`,
		tokenConfig(token)
	);

export const machineUtilTimeAnnualAction = (reqBody, token) =>
	axios.post(`${machineUtilRoot}/runtime`, reqBody, tokenConfig(token));

export const machineUtilTimeMonthAction = (reqBody, token) =>
	axios.post(`${machineUtilRoot}/runtime`, reqBody, tokenConfig(token));

export const annualTempPreferenceAction = (reqBody, token) =>
	axios.post(`${machineUtilRoot}/temperature`, reqBody, tokenConfig(token));

export const monthTempPreferenceAction = (reqBody, token) =>
	axios.post(`${machineUtilRoot}/temperature`, reqBody, tokenConfig(token));

export const numberOfCycleDayReportAction = (reqBody, token) =>
	axios.post(`${machineUtilRoot}/numberofcycleDay`, reqBody, tokenConfig(token));

export const numberOfCycleHourReportAction = (reqBody, token) =>
	axios.post(`${machineUtilRoot}/numberofcycleHour`, reqBody, tokenConfig(token));

export const utilizationReportAction = (reqBody, token) =>
	axios.post(`${machineUtilRoot}/utilizationReport`, reqBody, tokenConfig(token));

export const machineListAction = (reqBody, token) =>
  axios.post(`${machineUtilRoot}/machineList`, reqBody, tokenConfig(token));

// ********************************* outlet actions  *********************************
// outletReducer reducer actions
const outletRoot = localhost ? '/api/outlet/v1' : `${urlPicker}/api/outlet/v1`;

export const allOutletsAction = (operatorId, token) =>
	axios.get(`${outletRoot}/fetch?operatorId=${operatorId}`, tokenConfig(token));

export const allOutletsSummaryAction = (operatorId, token) =>
	axios.get(`${outletRoot}/fetch/summary?operatorId=${operatorId}`, tokenConfig(token));

export const allOutletsPingerLogAction = (operatorId, token) =>
	axios.get(`${outletRoot}/fetchPinger?operatorId=${operatorId}`, tokenConfig(token));

export const allOutletsDataOnlyAction = (operatorId, token) =>
	axios.get(`${outletRoot}/fetch/outlet_only?operatorId=${operatorId}`, tokenConfig(token));

export const allOutletsMyOutletsDataOnlyAction = (operatorId, token) =>
	axios.get(`${outletRoot}/fetch/my_outlet_only?operatorId=${operatorId}`, tokenConfig(token));

export const allOutletsDataOnlyReportAction = (operatorId, token) =>
	axios.get(`${outletRoot}/fetch/outlet_only_report?operatorId=${operatorId}`, tokenConfig(token));

export const allOutletsDataOnlyReportCollectionAction = (operatorId, token) =>
	axios.get(`${outletRoot}/fetch/outlet_only_report_collection?operatorId=${operatorId}`, tokenConfig(token));

export const fetchOutletsByRoleAction = (token) =>
	axios.get(`${outletRoot}/fetchByRole`, tokenConfig(token));

export const toggleKillSwitchAction = (reqBody, token) =>
	axios.put(`${outletRoot}/toggleKillSwitch`, reqBody, tokenConfig(token));

export const activateOutletAction = (reqBody, token) => axios.post(`${outletRoot}/activateOutlet`, reqBody, tokenConfig(token));
export const deactivateOutletAction = (reqBody, token) => axios.post(`${outletRoot}/deactivateOutlet`, reqBody, tokenConfig(token));
export const startMachineTrialAction = (reqBody, token) => axios.post(`${outletRoot}/startMachineTrial`, reqBody, tokenConfig(token));
export const endMachineTrialAction = (reqBody, token) => axios.post(`${outletRoot}/endMachineTrial`, reqBody, tokenConfig(token));

export const createOutletAction = (reqBody, token) => axios.post(`${outletRoot}/create`, reqBody, tokenConfig(token));
export const updateOutletAction = (reqBody, token) => axios.put(`${outletRoot}/edit`, reqBody, tokenConfig(token));

// ********************************* pricing strategy *********************************
export const updateOutletGroupingAction = (reqBody, token) =>
	axios.patch(`${outletRoot}/machine_grouping/edit`, reqBody, tokenConfig(token));

// priceSettingReducer
const priceRoot = localhost ? '/api/pricing/v1/strategy' : `${urlPicker}/api/pricing/v1/strategy`;
const priceRoot2 = localhost ? '/api/pricing/v2/strategy' : `${urlPicker}/api/pricing/v2/strategy`;

export const getPriceListAction = (operatorId, token) =>
	axios.get(`${priceRoot2}/fetch?operatorId=${operatorId}`, tokenConfig(token));

export const addPricingAction = (newPrice, token) => axios.post(`${priceRoot2}/add`, newPrice, tokenConfig(token));

export const assignPricingAction = (newPrice, token) => axios.put(`${priceRoot2}/assign`, newPrice, tokenConfig(token));

export const editPricingAction = (updateData, token) => axios.put(`${priceRoot2}/edit`, updateData, tokenConfig(token));

export const editPricingActionv2 = (updateData, token) => axios.put(`${priceRoot2}/secondary/edit`, updateData, tokenConfig(token));

export const deletePricingAction = (resData, token) => {
	return axios.delete(`${priceRoot2}/delete`, {
		...tokenConfig(token),
		data: resData,
	});
};

export const getModeListAction = (operatorId, token) =>
	axios.get(`${priceRoot2}/mode/fetch?operatorId=${operatorId}`, tokenConfig(token));

export const getModeListActionv2 = (dataPromo, token) => axios.post(`${priceRoot2}/mode/fetch2`, dataPromo, tokenConfig(token));

// ********************************* pricing promotion *********************************
// promotion actions /api/pricing/v1/promotion/
const promotionRoot = localhost ? '/api/pricing/v1/promotion' : `${urlPicker}/api/pricing/v1/promotion`;

export const getPromotionListAction = (operatorId, token) =>
	axios.get(`${promotionRoot}/fetch?operatorId=${operatorId}`, tokenConfig(token));

export const addPromotionAction = (newPrice, token) => axios.post(`${promotionRoot}/add`, newPrice, tokenConfig(token));

export const assignPromotionAction = (newPrice, token) =>
	axios.put(`${promotionRoot}/assign`, newPrice, tokenConfig(token));

export const editPromotionAction = (updateData, token) =>
	axios.put(`${promotionRoot}/edit`, updateData, tokenConfig(token));

export const deletePromotionAction = (id) => {
	return axios.delete(`${promotionRoot}/delete`, {
		...tokenConfig(),
		data: { id },
	});
};

// ********************************* news management *********************************
const newsRoot = localhost ? '/api/management/v3/news' : `${urlPicker}/api/management/v3/news`;

export const fetchNewsAction = (token) => axios.get(`${newsRoot}/fetch`, tokenConfig(token));
export const fetchActiveNewsAction = (token) => axios.get(`${newsRoot}/fetch-active`, tokenConfig(token));
export const createNewsAction = (formData, token) => axios.post(`${newsRoot}/create`, formData, tokenConfig(token));
export const editNewsAction = (formData, token) => axios.put(`${newsRoot}/edit`, formData, tokenConfig(token));
export const deleteNewsAction = (reqBody, token) => {
	return axios.post(`${newsRoot}/delete`, reqBody, tokenConfig(token));
};

// ********************************* package management *********************************
const packageRoot = localhost ? '/api/management/v3/package' : `${urlPicker}/api/management/v3/package`;

export const fetchPackagesAction = (token) => axios.get(`${packageRoot}/fetch`, tokenConfig(token));
export const fetchActivePackagesAction = (token, channel) =>
	axios.get(`${packageRoot}/fetch-active`, { ...tokenConfig(token), params: channel ? { channel } : {} });
export const createPackageAction = (reqBody, token) => axios.post(`${packageRoot}/create`, reqBody, tokenConfig(token));
export const editPackageAction = (reqBody, token) => axios.put(`${packageRoot}/edit`, reqBody, tokenConfig(token));
export const deletePackageAction = (reqBody, token) => axios.post(`${packageRoot}/delete`, reqBody, tokenConfig(token));

// ********************************* pricing strategy *********************************

// dropServiceReducer
const priceDropRoot = localhost ? '/api/pricing/v1/dropservice' : `${urlPicker}/api/pricing/v1/dropservice`;

export const getDropPriceListAction = (operatorId, token) =>
	axios.get(`${priceDropRoot}/fetch?operatorId=${operatorId}`, tokenConfig(token));

export const addDropPricingAction = (newPrice, token) => axios.post(`${priceDropRoot}/add`, newPrice, tokenConfig(token));

export const assignDropPricingAction = (newPrice, token) => axios.put(`${priceDropRoot}/assign`, newPrice, tokenConfig(token));

export const editDropPricingAction = (updateData, token) => axios.put(`${priceDropRoot}/edit`, updateData, tokenConfig(token));

export const deleteDropPricingAction = (resData, token) => {
	return axios.delete(`${priceDropRoot}/delete`, {
		...tokenConfig(token),
		data: resData,
	});
};

// ********************************* remote machine *********************************
// remoteReducer  reducer actions
const remoteRoot = localhost ? '/api/machine/v1' : `${urlPicker}/api/machine/v1`;

export const remoteMachineAction = (operatorId = '', outletId = '', token, coin = '') =>
	axios.get(`${remoteRoot}/fetch?operatorId=${operatorId}&outletId=${outletId}&coin=${coin}`, tokenConfig(token));

export const remoteFetchMachineAction = (operatorId = '', outletId = '', token, coin = '') =>
	axios.get(`${remoteRoot}/fetch_remote?operatorId=${operatorId}&outletId=${outletId}&coin=${coin}`, tokenConfig(token));

export const remoteActivateAction = (values, token) =>
	axios.post(`${remoteRoot}/remote_activate`, values, tokenConfig(token));

export const machineMonitorAction = (values, token) =>
	axios.put(`${remoteRoot}/monitoring`, values, tokenConfig(token));

export const machineMonitorEnabledAction = (values, token) =>
	axios.put(`${remoteRoot}/enabling`, values, tokenConfig(token));

export const stopMachineAction = (values, token) => axios.post(`${remoteRoot}/remote_stop`, values, tokenConfig(token));

// universal query
export const typesLookupAction = () => axios.get(`${remoteRoot}/template/lookup`, tokenConfig());

export const allMachinesAction = (operatorId, outletId, coin, token) =>
	axios.get(`${remoteRoot}/fetch?&operatorId=${operatorId}&outletId=${outletId}&coin=${coin}`, tokenConfig(token));

export const fetchInvoiceAction = (operatorId = '', outletId = '', token, coin = '', status = '') =>
	axios.get(`${remoteRoot}/fetchInvoice?operatorId=${operatorId}&outletId=${outletId}&coin=${coin}&status=${status}`, tokenConfig(token));

export const downloadInvoiceAction = (invoiceNumber, token) =>
	axios.post(`${remoteRoot}/downloadInvoice`, { invoiceNumber }, {
		...tokenConfig(token),
		responseType: 'blob'
	});

// ********************************* machine reports *********************************
// report reducer actions
const reportRoot = localhost ? '/api/report/sales/v1' : `${urlPicker}/api/report/sales/v1`;
const errorReportRoot = localhost ? '/api/report/errorcode/v1' : `${urlPicker}/api/report/errorcode/v1`;
const reportRootV2 = localhost ? '/api/report/sales/v2' : `${urlPicker}/api/report/sales/v2`;

export const getPaymentTypesAction = (token) => axios.get(`${reportRoot}/epayment/methods`, tokenConfig(token));

export const getTerminalTypesAction = (token) => axios.get(`${reportRoot}/terminal/methods`, tokenConfig(token));

export const getOverallEpaymentTypesAction = (token) => axios.get(`${reportRoot}/overallEpayment/methods`, tokenConfig(token));

export const getepaymentrecordAction = (values, token) => axios.post(`${reportRoot}/epayment/record`, values, tokenConfig(token));

export const getDNGPaymentTypesAction = (token) => axios.get(`${reportRoot}/dng/methods`, tokenConfig(token));

export const getCostingPaymentTypesAction = (token) => axios.get(`${reportRoot}/costing/methods`, tokenConfig(token));

export const transReportAction = (values, token) =>
	axios.post(`${reportRoot}/transactions`, values, tokenConfig(token));

export const transReportDownloadAction = (values, token) =>
	axios.post(`${reportRoot}/transactions/export`, values, {
		...tokenConfig(token),
		responseType: "blob"
	});

export const kioskReportAction = (values, token) =>
	axios.post(`${reportRootV2}/kioskpay`, values, tokenConfig(token));

export const voidTransactionAction = (cycleIds, isVoid, token) =>
	axios.post(`${reportRoot}/void-transaction`, { cycleIds, void: isVoid }, tokenConfig(token));

export const voidVendingAction = (transactionId, isVoid, token) =>
	axios.post(`${reportRoot}/void-vending`, { transactionId, void: isVoid }, tokenConfig(token));

export const saveColumnVisibilityAction = (hiddenColumns, report_type, token) =>
	axios.post(`${reportRoot}/update-column-visibility`, { hiddenColumns, report_type }, tokenConfig(token));

export const fetchColumnVisibilityAction = (report_type, token) =>
	axios.get(`${reportRoot}/fetch-column-visibility?report_type=${report_type}`, tokenConfig(token));

// Favorite menus
export const saveFavoriteMenusAction = (favoriteMenus, token) =>
	axios.post(`${reportRoot}/save-favorite-menus`, { favoriteMenus }, tokenConfig(token));

export const fetchFavoriteMenusAction = (token) =>
	axios.get(`${reportRoot}/fetch-favorite-menus`, tokenConfig(token));

// Save favorite search
export const saveFavoriteSearchAction = (favoriteSearch, token) =>
	axios.post(`${reportRoot}/save-favorite-search`, favoriteSearch, tokenConfig(token));

// Fetch favorite search
export const fetchFavoriteSearchAction = (token) =>
	axios.get(`${reportRoot}/fetch-favorite-search`, tokenConfig(token));

export const editFavoriteSearchAction = (favoriteSearch, token) =>
	axios.put(`${reportRoot}/edit-favorite-search`, favoriteSearch, tokenConfig(token));

export const deleteFavoriteSearchAction = (favoriteSearchId, token) =>
	axios.delete(`${reportRoot}/delete-favorite-search`, {
		data: { favoriteSearchId },
		...tokenConfig(token),
	});

// User Preferences
export const saveUserPreferenceAction = (preference, token) =>
	axios.post(`${reportRoot}/save-user-preference`, preference, tokenConfig(token));

export const fetchUserPreferenceAction = (token) =>
	axios.get(`${reportRoot}/fetch-user-preference`, tokenConfig(token));

export const summaryReportAction = (values, token) =>
	axios.post(`${reportRootV2}/sales_summary`, values, tokenConfig(token));

export const summaryReportOverallAction = (values, token) =>
	axios.post(`${reportRootV2}/sales_summary/overallv2`, values, tokenConfig(token));

export const summaryReportOverallConsolidatedAction = (values, token) =>
	axios.post(`${reportRootV2}/sales_summary/overall-consolidated`, values, tokenConfig(token));

export const epayReportAction = (values, token) => axios.post(`${reportRoot}/epayment`, values, tokenConfig(token));
export const manualPayReportAction = (values, token) =>
	axios.post(`${reportRoot}/manualpay`, values, tokenConfig(token));
export const terminalReportAction = (values, token) => axios.post(`${reportRoot}/terminal`, values, tokenConfig(token));
export const overallEpaymentReportAction = (values, token) => axios.post(`${reportRootV2}/overallEpayment`, values, tokenConfig(token));

export const dngReportAction = (values, token) => axios.post(`${reportRoot}/dng`, values, tokenConfig(token));

export const vendingReportAction = (values, token) => axios.post(`${reportRoot}/vending`, values, tokenConfig(token));

export const costingReportAction = (values, token) => axios.post(`${reportRoot}/costing`, values, tokenConfig(token));


export const errorcodeReportAction = async (values, token) =>
	await axios.post(`${errorReportRoot}/fetch`, values, tokenConfig(token));

export const billReportAction = (values, token) => axios.post(`${reportRoot}/bill`, values, tokenConfig(token));

export const getSubscriptionPaymentTypesAction = (token) => axios.get(`${reportRootV2}/subscription/methods`, tokenConfig(token));

export const subscriptionReportAction = (values, token) => axios.post(`${reportRootV2}/subscription`, values, tokenConfig(token));

export const pnlReportAction = (values, token) => axios.post(`${reportRootV2}/pnlrecord`, values, tokenConfig(token));

export const unresolvedReportAction = (values, token) => {
	return axios.post(`${reportRoot}/unresolved`, values, tokenConfig(token));
};

export const resolveUnresolvedAction = (values, token) => {
	return axios.post(`${reportRoot}/unresolved/resolve`, values, tokenConfig(token));
};

// ********************************* review feedback *********************************
export const machineSalesTransReportAction = (values, token) =>
	axios.post(`${reportRoot}/machine`, values, tokenConfig(token));

export const hourlySalesTransReportAction = (values, token) =>
	axios.post(`${reportRoot}/sales/hourly`, values, tokenConfig(token));

export const salesByMachineTypeAction = (values, token) =>
	axios.post(`${reportRoot}/machine_type`, values, tokenConfig(token));

// systemErrorReportAction
const errorStatusRoot = localhost ? '/api/report/errorcode/v1' : `${urlPicker}/api/report/errorcode/v1`;
export const systemErrorReportAction = (values, token) =>
	axios.post(`${errorStatusRoot}/alertsystem/fetch`, values, tokenConfig(token));

export const systemErrorReportUpdateAction = (values, token) =>
	axios.put(`${errorStatusRoot}/alertsystem/status/update`, values, tokenConfig(token));

//todo

// reviewDashReducer reducer actions
const reviewsRoot = localhost ? '/api/feedback/v1' : `${urlPicker}/api/feedback/v1`;
export const getReviewsAction = (query, token) => axios.get(`${reviewsRoot}/fetch?${query}`, tokenConfig(token));

export const resolveReviewAction = (reqBody, token) => axios.put(`${reviewsRoot}/resolve`, reqBody, tokenConfig(token));

export const sendReplyAction = (reqBody, token) => axios.post(`${reviewsRoot}/reply`, reqBody, tokenConfig(token));
export const getNotificationsAction = (token) => {
	return axios.get(`${reviewsRoot}/notifications`, tokenConfig(token));
};

export const markNotificationAsReadAction = (id, token) => {
	return axios.put(`${reviewsRoot}/notifications/read`, { id }, tokenConfig(token));
}

export const markAllNotificationsAsReadAction = (token) => {
	return axios.put(`${reviewsRoot}/notifications/readall`, {}, tokenConfig(token));
}

// ********************************* sales data *********************************
// sales data reducer actions
const salesRoot = localhost ? '/api/report/sales/v1' : `${urlPicker}/api/report/sales/v1`;
const salesRootV2 = localhost ? '/api/report/sales/v2' : `${urlPicker}/api/report/sales/v2`;

export const annualSalesReportAction = (reqBody, token) =>
	axios.post(`${salesRoot}/annual`, reqBody, tokenConfig(token));

export const annualSalesReportActionv2 = (reqBody, token) =>
	axios.post(`${salesRootV2}/totalAnnual`, reqBody, tokenConfig(token));

export const totalDailySalesByMonthAction = (reqBody, token) =>
	axios.post(`${salesRootV2}/monthly`, reqBody, tokenConfig(token));

export const totalDailySalesBy30daysAction = (reqBody, token) =>
	axios.post(`${salesRootV2}/30days`, reqBody, tokenConfig(token));

export const totalAnnualBillSalesAction = (reqBody, token) =>
	axios.post(`${salesRootV2}/totalAnnual/bill`, reqBody, tokenConfig(token));

export const totalDailyBillSalesByMonthAction = (reqBody, token) =>
	axios.post(`${salesRootV2}/monthly/bill`, reqBody, tokenConfig(token));

export const totalOutletSalesByYearAction = (year, operatorId, token) =>
	axios.get(`${salesRootV2}/type/outlet?year=${year}&operatorId=${operatorId}`, tokenConfig(token));

export const todaySalesAction = (operatorId, token) =>
	axios.get(`${salesRoot}/today/outlets?operatorId=${operatorId}`, tokenConfig(token));

export const totalOutletSalesMonthAction = (year, month, operatorId, token) =>
	axios.get(`${salesRootV2}/type/outlet?year=${year}&month=${month}&operatorId=${operatorId}`, tokenConfig(token));

export const annualBillReportAction = (year, operatorId, token) =>
	axios.post(`${salesRoot}/bill/outlet`, { year, operatorId }, tokenConfig(token));

export const billReportMonthAction = (year, month, operatorId, token) =>
	axios.post(`${salesRoot}/bill/outlet`, { year, operatorId, month }, tokenConfig(token));

export const dailySalesReportAction = (date, operatorId, token) =>
	axios.get(`${salesRoot}/type/outlet?date=${date}&operatorId=${operatorId}`, tokenConfig(token));

export const dailySalesWithUtilAction = (date, operatorId, outletSingleId, token) =>
	axios.post(`${salesRoot}/daily/machine`, { date, operatorId, outletId: outletSingleId }, tokenConfig(token));

//pie , first api for sales performance
export const annualTypeDistributionAction = (reqBody, token) =>
	axios.post(`${salesRootV2}/distribution/machine_type`, reqBody, tokenConfig(token));

//pie , second api for sales performance
export const annualWeightDistributionAction = (reqBody, token) =>
	axios.post(`${salesRootV2}/distribution/machine_weight`, reqBody, tokenConfig(token));

//pie , third api for sales performance
export const monthTypeDistributionAction = (reqBody, token) =>
	axios.post(`${salesRootV2}/distribution/machine_type`, reqBody, tokenConfig(token));

//pie , fourth api for sales performance
export const monthWeightDistributionAction = (reqBody, token) =>
	axios.post(`${salesRootV2}/distribution/machine_weight`, reqBody, tokenConfig(token));

// sum dash reducer actions
export const channelSalesAction = (year, operatorId, token) =>
	axios.get(`${salesRoot}/type/channel?year=${year}&operatorId=${operatorId}`, tokenConfig(token));

export const machineSalesAction = (year, operatorId, token) =>
	axios.get(`${salesRoot}/type/machine?year=${year}&operatorId=${operatorId}`, tokenConfig(token));

export const weeklySalesAction = (year, operatorId, token) =>
	axios.get(`${salesRoot}/weekly?year=${year}&operatorId=${operatorId}`, tokenConfig(token));

export const weeklySalesYearAction = (year, outlets, operatorId, token) =>
	axios.get(`${salesRoot}/weekly/year?year=${year}&outlets=${outlets.join(',')}&operatorId=${operatorId}`, tokenConfig(token));

// requestEndpoints.js
export const weeklySalesByMonthAction = (postObj, token) =>
	axios.post(`${salesRoot}/weekly/month`, postObj, tokenConfig(token));

const sumDRoot = localhost ? '/api/machine/v1' : `${urlPicker}/api/machine/v1`;

// console.log('tokenConfig()', tokenConfig())
export const machineStatusAction = (year, operatorId, token) => {
	return axios.get(`${sumDRoot}/status?year=${year}&operatorId=${operatorId}`, tokenConfig(token));
};

export const machineBillStatusAction = (year, operatorId, token) => {
	return axios.get(`${sumDRoot}/status/bill?year=${year}&operatorId=${operatorId}`, tokenConfig(token));
};

export const outOfServiceMachineStatusAction = (year, operatorId, token) => {
	return axios.get(`${sumDRoot}/outOfService?year=${year}&operatorId=${operatorId}`, tokenConfig(token));
};

export const offlineMachineStatusAction = (year, operatorId, token) => {
	return axios.get(`${sumDRoot}/offlineMachines?year=${year}&operatorId=${operatorId}`, tokenConfig(token));
};

export const unconfiguredMachineStatusAction = (year, operatorId, token) => {
	return axios.get(`${sumDRoot}/unconfiguredMachines?year=${year}&operatorId=${operatorId}`, tokenConfig(token));
};

export const billAcceptorSalesAction = (year, operatorId, token) =>
	axios.get(`${salesRoot}/type/billacceptor?year=${year}&operatorId=${operatorId}`, tokenConfig(token));

export const mtdSalesAction = (operatorId, token) =>
	axios.get(`${salesRoot}/mtd/outlets?operatorId=${operatorId}`, tokenConfig(token));

export const todayMachineSalesAction = (outletId, token) =>
	axios.get(`${salesRoot}/today/machines?outletId=${outletId}`, tokenConfig(token));

export const mtdMachineSalesAction = (outletId, token) =>
	axios.get(`${salesRoot}/mtd/machines?outletId=${outletId}`, tokenConfig(token));

export const monthlyOutletSalesAction = (year, operatorId, token) =>
	axios.get(`${salesRoot}/monthly/outlets?year=${year}&operatorId=${operatorId}`, tokenConfig(token));

export const dailyOutletSalesAction = (year, month, operatorId, token) =>
	axios.get(`${salesRoot}/daily/outlets?year=${year}&month=${month}&operatorId=${operatorId}`, tokenConfig(token));

export const monthlysingleOutletSalesAction = (year, outletId, token) =>
	axios.get(`${salesRoot}/monthly/single-outlet?year=${year}&outletId=${outletId}`, tokenConfig(token));

export const dailySingleOutletSalesAction = (year, month, outletId, token) =>
	axios.get(`${salesRoot}/daily/single-outlet?year=${year}&month=${month}&outletId=${outletId}`, tokenConfig(token));

// Bill Acceptor Sales (Today) – All Outlets
export const billAcceptorTodaySalesAction = (operatorId, token) =>
	axios.get(`${salesRootV2}/bill/today/outlets?operatorId=${operatorId}`, tokenConfig(token));

// Bill Acceptor Sales (MTD) – All Outlets
export const billAcceptorMTDSalesAction = (operatorId, token) =>
	axios.get(`${salesRootV2}/bill/mtd/outlets?operatorId=${operatorId}`, tokenConfig(token));

// Bill Acceptor Sales (Monthly) – All Outlets
export const billAcceptorMonthlyOutletSalesAction = (year, operatorId, token) =>
	axios.get(`${salesRootV2}/bill/monthly/outlets?year=${year}&operatorId=${operatorId}`, tokenConfig(token));

// Bill Acceptor Sales (Daily) – All Outlets
export const billAcceptorDailyOutletSalesAction = (year, month, operatorId, token) =>
	axios.get(`${salesRootV2}/bill/daily/outlets?year=${year}&month=${month}&operatorId=${operatorId}`, tokenConfig(token));

// Bill Acceptor Sales (Monthly) – Single Outlet
export const billAcceptorMonthlySingleSalesAction = (year, outletId, token) =>
	axios.get(`${salesRootV2}/bill/monthly/single-outlet?year=${year}&outletId=${outletId}`, tokenConfig(token));

// Bill Acceptor Sales (Daily) – Single Outlet
export const billAcceptorDailySingleSalesAction = (year, month, outletId, token) =>
	axios.get(`${salesRootV2}/bill/daily/single-outlet?year=${year}&month=${month}&outletId=${outletId}`, tokenConfig(token));

// Bill Acceptor Sales (Today) – Single Outlet
export const billAcceptorTodaySingleSalesAction = (outletId, token) =>
	axios.get(`${salesRootV2}/bill/today/single-outlet?outletId=${outletId}`, tokenConfig(token));

// Bill Acceptor Sales (MTD) – Single Outlet
export const billAcceptorMTDSingleSalesAction = (outletId, token) =>
	axios.get(`${salesRootV2}/bill/mtd/single-outlet?outletId=${outletId}`, tokenConfig(token));

// ********************************* user reducer *********************************
// user reducer actions

const userRoot = localhost ? '/api/auth/v1' : `${urlPicker}/api/auth/v1`;

export const resetPasswordAction = (updatedUser) => axios.put(`${userRoot}/password/reset`, updatedUser);

export const sendResetEmailAction = (body) =>
	axios.get(
		`${userRoot}/password/forget?email=${body.email}&brand=${body.brand}&role=${body.role}&domain=${body.domain}`
	);

export const sendChangeEmailLinkAction = (body, token) => axios.post(`${userRoot}/email/magiclink`, body, tokenConfig(token));

export const getResolveConfigAction = (body, token) => axios.post(`${userRoot}/unresolve/status`, body, tokenConfig(token));

export const updateResolveConfigAction = (body, token) => axios.post(`${userRoot}/unresolve/configure`, body, tokenConfig(token));

export const verifyChangeEmailLinkAction = (token) => axios.post(`${userRoot}/email/verify`, { token });

export const loginStaffAction = (loginUser) => axios.post(`${userRoot}/staff/login`, loginUser, config);

export const verifyStaffAction = (id, otp) => axios.post(`${userRoot}/staff/verify`, id, otp, config);

export const registerStaffAction = (newUser) => axios.post(`${userRoot}/staff/register`, newUser, config);

export const registerOperatorAction = (newUser) => axios.post(`${userRoot}/operator/register`, newUser, config);

export const verifyOperatorAction = (token) => axios.post(`${userRoot}/verify/account`, { token }, config);

export const loginOperatorAction = (loginUser) => axios.post(`${userRoot}/operator/login`, loginUser, config);

export const verifyOtpOperatorAction = (id, otp) => axios.post(`${userRoot}/operator/verify`, id, otp, config);

export const checkSessionAction = (token) => axios.post(`${userRoot}/session`, { token }, config);

export const changePasswordAction = (values) => axios.put(`${userRoot}/password/reset`, values, config);

export const loyaltyAdminCheckAction = (token) => axios.get(`${userRoot}/loyalty/login`, tokenConfig(token));

export const loginDistributorAction = (values) => axios.post(`${userRoot}/distributor/login`, values, config);

export const verifyDistributorAction = (id, otp) => axios.post(`${userRoot}/distributor/verify`, id, otp, config);

export const loginClientAction = (values) => axios.post(`${userRoot}/client/login`, values, config);

export const fetch2faAction = (token) => axios.get(`${userRoot}/check2fa`, tokenConfig(token));

export const verifyUser2faAction = (sendBody, token) => axios.post(`${userRoot}/user/verify2fa`, sendBody, tokenConfig(token));

// Admin routes
export const loginAdminAction = (loginUser) => axios.post(`${userRoot}/admin/login`, loginUser, config);

// ********************************* Revenue Monster *********************************
const userManagementRoot = localhost ? '/api/management/v1' : `${urlPicker}/api/management/v1`;
const userManagementRootV2 = localhost ? '/api/management/v2' : `${urlPicker}/api/management/v2`;
const salesRootv1 = localhost ? '/api/report/sales/v1' : `${urlPicker}/api/report/sales/v1`;
const notificationEngineRoot = localhost ? '/api/notificationengine/v1' : `${urlPicker}/api/notificationengine/v1`;

export const addNewUserAction = (newUser, token) =>
	axios.post(`${userManagementRoot}/user/create`, newUser, tokenConfig(token));

export const updateUserAction = (updateData, token) =>
	axios.put(`${userManagementRoot}/user/edit`, updateData, tokenConfig(token));

export const checkUsernameAvailabilityAction = (reqBody, token) =>
	axios.post(`${userManagementRoot}/checkUsername`, reqBody, tokenConfig(token));

export const checkEmailAvailabilityAction = (reqBody, token) =>
	axios.post(`${userManagementRoot}/checkEmail`, reqBody, tokenConfig(token));

export const toggleUserActiveAction = (toggleData, token) =>
	axios.post(`${userManagementRoot}/user/toggleActive`, toggleData, tokenConfig(token));

export const updateOutletVisibilityAction = (updateData, token) =>
	axios.put(`${userManagementRoot}/controller/outlet_controller`, updateData, tokenConfig(token));

export const updateOutletVisibilityActionv2 = (updateData, token) =>
	axios.put(`${userManagementRoot}/controller/outlet_controllerv2`, updateData, tokenConfig(token));

export const updateOperatorVisibilityAction = (updateData, token) =>
	axios.put(`${userManagementRoot}/controller/operator_controller`, updateData, tokenConfig(token));

export const fetchDistributorUsersAction = (token) =>
	axios.post(`${userManagementRoot}/fetch/distributorUsers`, {}, tokenConfig(token));

export const fetchAssignedDistributorUsersAction = (reqBody, token) =>
	axios.post(`${userManagementRoot}/controller/distributor_controller/fetch`, reqBody, tokenConfig(token));

export const assignDistributorUsersAction = (updateData, token) =>
	axios.post(`${userManagementRoot}/controller/distributor_controller`, updateData, tokenConfig(token));

//

export const getUsersListAction = (token, userType) => {
	// Construct the query parameters
	const query = [
		userType ? `userType=${userType}` : ''
	]
		.filter(Boolean)
		.join('&');

	// Construct the full URL with query string
	const url = `${userManagementRoot}/user/fetch${query ? `?${query}` : ''}`;

	return axios.get(url, tokenConfig(token));
};

export const getUserRoleListAction = (token) => axios.get(`${userManagementRoot}/role/fetch`, tokenConfig(token));

export const getUserPermissionsAction = (token) =>
	axios.get(`${userManagementRoot}/permissions/fetch`, tokenConfig(token));

export const addUserRoleAction = (newRole, token) =>
	axios.post(`${userManagementRoot}/role/create`, newRole, tokenConfig(token));

export const assignUserRoleAction = (newRole, token) =>
	axios.put(`${userManagementRoot}/role/assign`, newRole, tokenConfig(token));

export const editUserRoleAction = (updateData, token) =>
	axios.put(`${userManagementRoot}/role/edit`, updateData, tokenConfig(token));

export const deleteUserRoleAction = (id) => {
	return axios.delete(`${userManagementRoot}/delete`, {
		...tokenConfig(),
		data: { id },
	});
};

export const killSwitchAction = (token, kill, securityCode) =>
	axios.post(
		`${userManagementRoot}/updateKill`,
		{ kill, securityCode },
		tokenConfig(token)
	);

export const killCountAction = (token, kill, securityCode) => axios.post(`${userManagementRoot}/getKill`, { kill, securityCode }, tokenConfig(token));

export const getNodeCloudOutletsAction = (outlets, token) =>
	axios.post(`${userManagementRootV2}/nodecloud/getOutlet`, { outlets }, tokenConfig(token));

export const assignOutletAction = (userId, outletIds, outletOptions, token) =>
	axios.post(`${userManagementRootV2}/nodecloud/assignOutlet`, { userId, outletIds, outletOptions }, tokenConfig(token));

export const registerCloudUserAction = (username, password, outletIds, operatorId, token) =>
	axios.post(`${userManagementRootV2}/nodecloud/registerOperator`, { username, password, outletIds, operatorId }, tokenConfig(token));

export const getNodeCloudUserAction = (username, token) =>
	axios.post(`${userManagementRootV2}/nodecloud/getUser`, { username }, tokenConfig(token));

export const syncStaffOutletPermissionsAction = (token) => axios.get(`${userManagementRoot}/controller/permission/staff`, tokenConfig(token));

export const syncDistributorUserOutletPermissionsAction = (token) => axios.get(`${userManagementRoot}/controller/permission/distributoruser`, tokenConfig(token));

export const syncStaffOperatorControllerAction = (token) => axios.get(`${userManagementRoot}/controller/operator/staff`, tokenConfig(token));

export const syncDistributorUserOperatorControllerAction = (token) => axios.get(`${userManagementRoot}/controller/operator/distributoruser`, tokenConfig(token));

export const importDataAction = (newData, token) => axios.post(`${userManagementRoot}/import`, newData, tokenConfig(token));

export const getDataAction = (token) => axios.get(`${userManagementRoot}/checkTerminal`, tokenConfig(token));

export const getTerminalAction = (token) => axios.get(`${userManagementRoot}/getTerminal`, tokenConfig(token));

export const getUserNotificationAction = (token) => axios.get(`${userManagementRoot}/user/notification`, tokenConfig(token));

export const updateNotificationAction = (updateData, token) =>
	axios.post(`${userManagementRoot}/update/notification`, updateData, tokenConfig(token));

export const getNotificationCredentialAction = (token, operatorId) =>
	axios.post(`${notificationEngineRoot}/getCredential`, operatorId ? { operatorId } : {}, tokenConfig(token));

export const getDistributorUserCredentialAction = (reqBody, token) =>
	axios.post(`${notificationEngineRoot}/getDistributorUserCredential`, reqBody, tokenConfig(token));

export const getClientUserCredentialAction = (reqBody, token) =>
	axios.post(`${notificationEngineRoot}/getClientUserCredential`, reqBody, tokenConfig(token));

export const addNotificationCredentialAction = (payload, token) =>
	axios.post(`${notificationEngineRoot}/addCredential`, payload, tokenConfig(token));

export const getNotificationTemplatesAction = (payload, token) =>
	axios.post(`${notificationEngineRoot}/getTemplates`, payload, tokenConfig(token));

export const unconfigureNotificationCredentialAction = (payload, token) =>
	axios.post(`${notificationEngineRoot}/unconfigureCredential`, payload, tokenConfig(token));

export const blastEmailAction = (payload, token) =>
	axios.post(`${notificationEngineRoot}/blastEmail`, payload, tokenConfig(token));

export const blastSmsAction = (payload, token) =>
	axios.post(`${notificationEngineRoot}/blastSMS`, payload, tokenConfig(token));

export const einvoiceListAction = (operatorId, statusFilter, token) =>
	axios.get(`${userManagementRootV2}/einvoice/dashboard?operatorId=${operatorId}&statusFilter=${statusFilter}`, tokenConfig(token));

export const fetchInvoiceCyclesAction = (body, token) =>
	axios.post(`${userManagementRootV2}/einvoice/getcash`, body, tokenConfig(token));

export const submitSelectedCycleAction = (id, token) =>
	axios.post(`${userManagementRootV2}/einvoice/update`, { id }, tokenConfig(token));

export const fetchConsolidateListAction = (operatorId, token) =>
	axios.get(`${userManagementRootV2}/consolidate/dashboard?operatorId=${operatorId}`, tokenConfig(token));

export const fetchAllDataConsolidateAction = (body, token) =>
	axios.post(`${userManagementRootV2}/consolidate/getdata`, body, tokenConfig(token));

export const submitSelectedOutletAction = (id, token) =>
	axios.post(`${userManagementRootV2}/consolidate/update`, { id }, tokenConfig(token));

export const einvoiceListEpaymentAction = (operatorId, statusFilter, token) =>
	axios.get(`${userManagementRootV2}/einvoice/dashboard/epayment?operatorId=${operatorId}&statusFilter=${statusFilter}`, tokenConfig(token));

export const fetchInvoiceEpaymentAction = (body, token) =>
	axios.post(`${userManagementRootV2}/einvoice/getepayment`, body, tokenConfig(token));

export const submitSelectedEpaymentAction = (id, token) =>
	axios.post(`${userManagementRootV2}/einvoice/update/epayment`, { id }, tokenConfig(token));

export const fetchEpaymentAction = (body, token) =>
	axios.post(`${salesRootv1}/getEpaymentById`, body, tokenConfig(token));

export const einvoiceReportAction = (values, token) => axios.post(`${userManagementRootV2}/einvoice/consolidation`, values, tokenConfig(token));

export const cancelSelectedCycleAction = (id, token) =>
	axios.post(`${userManagementRootV2}/einvoice/cancel`, { id }, tokenConfig(token));

export const cancelSelectedEpaymentAction = (id, token) =>
	axios.post(`${userManagementRootV2}/einvoice/epayment/cancel`, { id }, tokenConfig(token));

export const cancelConsolidateAction = (id, token) =>
	axios.post(`${userManagementRootV2}/consolidate/cancel`, { id }, tokenConfig(token));

export const einvoiceListPackageAction = (operatorId, statusFilter, token) =>
	axios.get(`${userManagementRootV2}/einvoice/dashboard/package?operatorId=${operatorId}&statusFilter=${statusFilter}`, tokenConfig(token));

export const cancelSelectedPackageAction = (id, token) =>
	axios.post(`${userManagementRootV2}/einvoice/cancel/package`, { id }, tokenConfig(token));

export const rejectSelectedCycleAction = (id, token) =>
	axios.post(`${userManagementRootV2}/einvoice/reject`, { id }, tokenConfig(token));

export const rejectSelectedEpaymentAction = (id, token) =>
	axios.post(`${userManagementRootV2}/einvoice/epayment/reject`, { id }, tokenConfig(token));

export const getClientUserAction = (token) =>
	axios.post(`${userManagementRoot}/clientuser/get`, {}, tokenConfig(token));

export const updateClientUserReportAction = (boolean, token) =>
	axios.post(`${userManagementRoot}/clientuser/disabled`, { boolean }, tokenConfig(token));

// monster action urls
const rmRoot = localhost ? '/api/rm/v1' : `${urlPicker}/api/rm/v1`;
const billingRoot = localhost ? '/api/billing/v1' : `${urlPicker}/api/billing/v1`;

export const createRMAction = (RmDetails, token) => axios.post(`${rmRoot}/create`, RmDetails, tokenConfig(token));

export const updateRMAction = (RmDetails, token) => axios.put(`${rmRoot}/rm/update`, RmDetails, tokenConfig(token));

export const updateRazerAction = (RazerDetails, token) => axios.put(`${rmRoot}/razer/update`, RazerDetails, tokenConfig(token));

export const updateDuitnowAction = (DuitnowDetails, token) => axios.put(`${rmRoot}/duitnow/update`, DuitnowDetails, tokenConfig(token));

export const updateGhlAction = (GhlDetails, token) => axios.put(`${rmRoot}/ghl/update`, GhlDetails, tokenConfig(token));

export const updateRhbAction = (RhbDetails, token) => axios.put(`${rmRoot}/rhb/update`, RhbDetails, tokenConfig(token));

export const fetchRMAction = (operatorId, token) =>
	axios.get(`${rmRoot}/fetch?operatorId=${operatorId}`, tokenConfig(token));

export const tokenkeyAction = (TokenkeyDetails, token) =>
	axios.post(`${rmRoot}/tokenkey`, TokenkeyDetails, tokenConfig(token));

export const fetchTokenkeyAction = (operatorId, token) =>
	axios.get(
		`${rmRoot}/fetch/tokenkey?operatorId=${operatorId}`,
		tokenConfig(token)
	);

export const createDuitnowAction = (DuitnowDetails, token) => axios.post(`${rmRoot}/duitnow/create`, DuitnowDetails, tokenConfig(token));

export const fetchDuitnowAction = (operatorId, token) =>
	axios.get(`${rmRoot}/duitnow/fetch?operatorId=${operatorId}`, tokenConfig(token));

export const tokenkeyDuitnowAction = (tokenkeyDuitnowDetails, token) =>
	axios.post(`${rmRoot}/duitnow/tokenkey`, tokenkeyDuitnowDetails, tokenConfig(token));

export const fetchTokenkeyDuitnowAction = (operatorId, token) =>
	axios.get(
		`${rmRoot}/duitnow/fetch/tokenkey?operatorId=${operatorId}`,
		tokenConfig(token)
	);

export const createAmpersandPayAction = (ampersandPayDetails, token) =>
	axios.post(`${rmRoot}/ampersandpay/create`, ampersandPayDetails, tokenConfig(token));

export const updateAmpersandPayAction = (ampersandPayDetails, token) =>
	axios.put(`${rmRoot}/ampersandpay/update`, ampersandPayDetails, tokenConfig(token));

export const fetchAmpersandPayAction = (operatorId, token) =>
	axios.get(`${rmRoot}/ampersandpay/fetch?operatorId=${operatorId}`, tokenConfig(token));

export const createRazerAction = (RazerDetails, token) => axios.post(`${rmRoot}/razerpay/create`, RazerDetails, tokenConfig(token));

export const fetchRazerAction = (operatorId, token) =>
	axios.get(`${rmRoot}/razer/fetch?operatorId=${operatorId}`, tokenConfig(token));


export const tokenkeyRazerAction = (TokenkeyDetails, token) =>
	axios.post(`${rmRoot}/razer/tokenkey`, TokenkeyDetails, tokenConfig(token));

export const fetchTokenkeyRazerAction = (operatorId, token) =>
	axios.get(
		`${rmRoot}/razer/fetch/tokenkey?operatorId=${operatorId}`,
		tokenConfig(token)
	);

export const createRhbAction = (RhbDetails, token) => axios.post(`${rmRoot}/rhb/create`, RhbDetails, tokenConfig(token));

export const fetchRhbAction = (operatorId, token) =>
	axios.get(`${rmRoot}/rhb/fetch?operatorId=${operatorId}`, tokenConfig(token));


export const tokenkeyRhbAction = (TokenkeyDetails, token) =>
	axios.post(`${rmRoot}/rhb/tokenkey`, TokenkeyDetails, tokenConfig(token));

export const fetchTokenkeyRhbAction = (operatorId, token) =>
	axios.get(
		`${rmRoot}/rhb/fetch/tokenkey?operatorId=${operatorId}`,
		tokenConfig(token)
	);

export const createGhlAction = (GhlDetails, token) => axios.post(`${rmRoot}/ghl/create`, GhlDetails, tokenConfig(token));

export const fetchGhlAction = (operatorId, token) =>
	axios.get(`${rmRoot}/ghl/fetch?operatorId=${operatorId}`, tokenConfig(token));


export const tokenkeyGhlAction = (TokenkeyDetails, token) =>
	axios.post(`${rmRoot}/ghl/tokenkey`, TokenkeyDetails, tokenConfig(token));

export const fetchTokenkeyGhlAction = (operatorId, token) =>
	axios.get(
		`${rmRoot}/ghl/fetch/tokenkey?operatorId=${operatorId}`,
		tokenConfig(token)
	);

////// SCAN2PAY OUTLET AND TOKEN CONFIG //////
export const createScan2PayAction = (Scan2PayDetails, token) =>
	axios.post(`${rmRoot}/scan2pay/create`, Scan2PayDetails, tokenConfig(token));

export const updateScan2PayAction = (Scan2PayDetails, token) =>
	axios.put(`${rmRoot}/scan2pay/update`, Scan2PayDetails, tokenConfig(token));

export const fetchScan2PayAction = (operatorId, token) =>
	axios.get(`${rmRoot}/scan2pay/fetch?operatorId=${operatorId}`, tokenConfig(token));

// FETCH SCAN2PAY TOKENKEY
export const fetchTokenkeyScan2PayAction = (operatorId, token) =>
	axios.get(
		`${rmRoot}/scan2Pay/fetch/tokenkey?operatorId=${operatorId}`,
		tokenConfig(token)
	);

// ADD/EDIT SCAN2PAY TOKENKEY
export const tokenkeyScan2PayAction = (TokenkeyDetails, token) =>
	axios.post(`${rmRoot}/scan2Pay/tokenkey`, TokenkeyDetails, tokenConfig(token));

////// KIPLE TOKEN AND OUTLET CONFIG //////
export const fetchTokenkeyKipleAction = (operatorId, token) =>
	axios.get(
		`${rmRoot}/kiple/fetch/tokenkey?operatorId=${operatorId}`,
		tokenConfig(token)
	);

export const tokenkeyKipleAction = (TokenkeyDetails, token) =>
	axios.post(`${rmRoot}/kiple/tokenkey`, TokenkeyDetails, tokenConfig(token));

export const createKipleAction = (KipleDetails, token) =>
	axios.post(`${rmRoot}/kiple/create`, KipleDetails, tokenConfig(token));

export const updateKipleAction = (KipleDetails, token) =>
	axios.put(`${rmRoot}/kiple/update`, KipleDetails, tokenConfig(token));

export const fetchKipleAction = (operatorId, token) =>
	axios.get(`${rmRoot}/kiple/fetch?operatorId=${operatorId}`, tokenConfig(token));

////// HITPAY TOKEN AND OUTLET CONFIG //////
export const fetchTokenkeyHitpayAction = (operatorId, token) =>
	axios.get(
		`${rmRoot}/hitpay/fetch/tokenkey?operatorId=${operatorId}`,
		tokenConfig(token)
	);

export const tokenkeyHitpayAction = (TokenkeyDetails, token) =>
	axios.post(`${rmRoot}/hitpay/tokenkey`, TokenkeyDetails, tokenConfig(token));

export const createHitpayAction = (HitpayDetails, token) =>
	axios.post(`${rmRoot}/hitpay/create`, HitpayDetails, tokenConfig(token));

export const updateHitpayAction = (HitpayDetails, token) =>
	axios.put(`${rmRoot}/hitpay/update`, HitpayDetails, tokenConfig(token));

export const fetchHitpayAction = (operatorId, token) =>
	axios.get(`${rmRoot}/hitpay/fetch?operatorId=${operatorId}`, tokenConfig(token));

////// PAGBANK TOKEN AND OUTLET CONFIG //////
export const fetchTokenkeyPagbankAction = (operatorId, token) =>
	axios.get(
		`${rmRoot}/pagbank/fetch/tokenkey?operatorId=${operatorId}`,
		tokenConfig(token)
	);

export const tokenkeyPagbankAction = (TokenkeyDetails, token) =>
	axios.post(`${rmRoot}/pagbank/tokenkey`, TokenkeyDetails, tokenConfig(token));

export const createPagbankAction = (PagbankDetails, token) =>
	axios.post(`${rmRoot}/pagbank/create`, PagbankDetails, tokenConfig(token));

export const updatePagbankAction = (PagbankDetails, token) =>
	axios.put(`${rmRoot}/pagbank/update`, PagbankDetails, tokenConfig(token));

export const fetchPagbankAction = (operatorId, token) =>
	axios.get(`${rmRoot}/pagbank/fetch?operatorId=${operatorId}`, tokenConfig(token));

////// 2C2P TOKEN AND OUTLET CONFIG //////
export const fetchTokenkey2c2pAction = (operatorId, token) =>
	axios.get(
		`${rmRoot}/2c2p/fetch/tokenkey?operatorId=${operatorId}`,
		tokenConfig(token)
	);

export const tokenkey2c2pAction = (TokenkeyDetails, token) =>
	axios.post(`${rmRoot}/2c2p/tokenkey`, TokenkeyDetails, tokenConfig(token));

export const create2c2pAction = (TwoCTwoPDetails, token) =>
	axios.post(`${rmRoot}/2c2p/create`, TwoCTwoPDetails, tokenConfig(token));

export const update2c2pAction = (TwoCTwoPDetails, token) =>
	axios.put(`${rmRoot}/2c2p/update`, TwoCTwoPDetails, tokenConfig(token));

export const fetch2c2pAction = (operatorId, token) =>
	axios.get(`${rmRoot}/2c2p/fetch?operatorId=${operatorId}`, tokenConfig(token));

////// CYBERSOURCE TOKEN AND OUTLET CONFIG //////
export const fetchTokenkeyCybersourceAction = (operatorId, token) =>
	axios.get(
		`${rmRoot}/cybersource/fetch/tokenkey?operatorId=${operatorId}`,
		tokenConfig(token)
	);

export const tokenkeyCybersourceAction = (TokenkeyDetails, token) =>
	axios.post(`${rmRoot}/cybersource/tokenkey`, TokenkeyDetails, tokenConfig(token));

export const createCybersourceAction = (CybersourceDetails, token) =>
	axios.post(`${rmRoot}/cybersource/create`, CybersourceDetails, tokenConfig(token));

export const updateCybersourceAction = (CybersourceDetails, token) =>
	axios.put(`${rmRoot}/cybersource/update`, CybersourceDetails, tokenConfig(token));

export const fetchCybersourceAction = (operatorId, token) =>
	axios.get(`${rmRoot}/cybersource/fetch?operatorId=${operatorId}`, tokenConfig(token));

////// BANGKOK BANK PROMPTPAY TOKEN AND OUTLET CONFIG //////
export const fetchTokenkeyBangkokBankPromptPayAction = (operatorId, token) =>
	axios.get(
		`${rmRoot}/bangkokbankpromptpay/fetch/tokenkey?operatorId=${operatorId}`,
		tokenConfig(token)
	);

export const tokenkeyBangkokBankPromptPayAction = (TokenkeyDetails, token) =>
	axios.post(`${rmRoot}/bangkokbankpromptpay/tokenkey`, TokenkeyDetails, tokenConfig(token));

export const createBangkokBankPromptPayAction = (BangkokBankPromptPayDetails, token) =>
	axios.post(`${rmRoot}/bangkokbankpromptpay/create`, BangkokBankPromptPayDetails, tokenConfig(token));

export const updateBangkokBankPromptPayAction = (BangkokBankPromptPayDetails, token) =>
	axios.put(`${rmRoot}/bangkokbankpromptpay/update`, BangkokBankPromptPayDetails, tokenConfig(token));

export const fetchBangkokBankPromptPayAction = (operatorId, token) =>
	axios.get(`${rmRoot}/bangkokbankpromptpay/fetch?operatorId=${operatorId}`, tokenConfig(token));

////// BANGKOK BANK DEEPLINK TOKEN AND OUTLET CONFIG //////
export const fetchTokenkeyBangkokBankDeeplinkAction = (operatorId, token) =>
	axios.get(
		`${rmRoot}/bangkokbankdeeplink/fetch/tokenkey?operatorId=${operatorId}`,
		tokenConfig(token)
	);

export const tokenkeyBangkokBankDeeplinkAction = (TokenkeyDetails, token) =>
	axios.post(`${rmRoot}/bangkokbankdeeplink/tokenkey`, TokenkeyDetails, tokenConfig(token));

export const createBangkokBankDeeplinkAction = (BangkokBankDeeplinkDetails, token) =>
	axios.post(`${rmRoot}/bangkokbankdeeplink/create`, BangkokBankDeeplinkDetails, tokenConfig(token));

export const updateBangkokBankDeeplinkAction = (BangkokBankDeeplinkDetails, token) =>
	axios.put(`${rmRoot}/bangkokbankdeeplink/update`, BangkokBankDeeplinkDetails, tokenConfig(token));

export const fetchBangkokBankDeeplinkAction = (operatorId, token) =>
	axios.get(`${rmRoot}/bangkokbankdeeplink/fetch?operatorId=${operatorId}`, tokenConfig(token));

////// PAYWAY TOKEN AND OUTLET CONFIG //////
export const fetchTokenkeyPaywayAction = (operatorId, token) =>
	axios.get(
		`${rmRoot}/payway/fetch/tokenkey?operatorId=${operatorId}`,
		tokenConfig(token)
	);

export const tokenkeyPaywayAction = (TokenkeyDetails, token) =>
	axios.post(`${rmRoot}/payway/tokenkey`, TokenkeyDetails, tokenConfig(token));

export const createPaywayAction = (PaywayDetails, token) =>
	axios.post(`${rmRoot}/payway/create`, PaywayDetails, tokenConfig(token));

export const updatePaywayAction = (PaywayDetails, token) =>
	axios.put(`${rmRoot}/payway/update`, PaywayDetails, tokenConfig(token));

export const fetchPaywayAction = (operatorId, token) =>
	axios.get(`${rmRoot}/payway/fetch?operatorId=${operatorId}`, tokenConfig(token));

////// RAZER OPA (FIUU OFFLINE PAYMENT API - KIOSK DUITNOW QR) CONFIG //////
export const createRazerOpaAction = (RazerOpaDetails, token) =>
	axios.post(`${rmRoot}/razeropa/create`, RazerOpaDetails, tokenConfig(token));

export const updateRazerOpaAction = (RazerOpaDetails, token) =>
	axios.put(`${rmRoot}/razeropa/update`, RazerOpaDetails, tokenConfig(token));

export const fetchRazerOpaAction = (operatorId, token) =>
	axios.get(`${rmRoot}/razeropa/fetch?operatorId=${operatorId}`, tokenConfig(token));

export const createCreditcardAction = (creditCardDetails, token) =>
	axios.post(`${billingRoot}/creditcard/create`, creditCardDetails, tokenConfig(token));

export const updateCreditcardAction = (creditCardDetails, token) =>
	axios.put(`${billingRoot}/creditcard/update`, creditCardDetails, tokenConfig(token));

export const fetchCreditcardAction = (operatorId, token) =>
	axios.get(`${billingRoot}/creditcard/fetch?operatorId=${operatorId}`, tokenConfig(token));

// Checkout placeholder endpoint (frontend uses this until backend is ready)
export const checkoutInvoicesAction = (payload, token) =>
    axios.post(`${billingRoot}/payment/checkout`, payload, tokenConfig(token));

// Checkout without credit card
export const checkoutWithoutCardAction = (payload, token) =>
    axios.post(`${billingRoot}/checkout`, payload, tokenConfig(token));

export const topupCheckoutAction = (reqBody, token) => axios.post(`${billingRoot}/topup/checkout`, reqBody, tokenConfig(token));


export const paymentHistoryAction = (body = {}, token) =>
	axios.post(`${billingRoot}/payment/history`, body, tokenConfig(token));


// Send invoice reminder
export const sendInvoiceReminderAction = (payload, token) =>
    axios.post(`${billingRoot}/sendInvoiceReminder`, payload, tokenConfig(token));

export const getReminderAction = (token) =>
    axios.get(`${billingRoot}/getReminder`, tokenConfig(token));

export const createCompanyAction = (CompanyDetails, token) => axios.post(`${rmRoot}/company/create`, CompanyDetails, tokenConfig(token));

export const fetchCompanyAction = (operatorId, token) =>
	axios.get(`${rmRoot}/company/fetch?operatorId=${operatorId}`, tokenConfig(token));

// role list && admin routes action urls
const adminRoot = localhost ? '/api/management/v1' : `${urlPicker}/api/management/v1`;
export const getRoleListAction = (token) => axios.get(`${adminRoot}/role/fetch`, tokenConfig(token));

export const getPermissionsAction = (token) => axios.get(`${adminRoot}/permissions/fetch`, tokenConfig(token));

export const addRoleAction = (newRole, token) => axios.post(`${adminRoot}/role/create`, newRole, tokenConfig(token));

export const assignRoleAction = (newRole, token) => axios.put(`${adminRoot}/role/assign`, newRole, tokenConfig(token));
//todo
export const editRoleAction = (updateData, token) =>
	axios.put(`${adminRoot}/role/edit`, updateData, tokenConfig(token));
//todo
export const deleteRoleAction = (id) => {
	return axios.delete(`${adminRoot}/delete`, {
		...tokenConfig(),
		data: { id },
	});
};

//

export const addUserAction = (reqBody, token) => axios.post(`${adminRoot}/user/create`, reqBody, tokenConfig(token));

export const addClientAction = (reqBody, token) =>
	axios.post(`${adminRoot}/client/create`, reqBody, tokenConfig(token));

export const getClientsAction = (token) => axios.get(`${adminRoot}/client/fetch`, tokenConfig(token));

export const getDistributorsAction = (token) => axios.get(`${adminRoot}/distributor/fetch`, tokenConfig(token));

export const getUsersAction = (token, role) =>
	axios.get(`${adminRoot}/user/fetch${role ? `?userType=${role}` : ''}`, tokenConfig(token));

export const assignOperatorAction = (reqBody, token) =>
	axios.put(`${adminRoot}/operator/assign`, reqBody, tokenConfig(token));

export const getClientUserOperatorsAction = (clientUserId, token) =>
	axios.get(`${adminRoot}/controller/client_user_operator?clientUserId=${encodeURIComponent(clientUserId)}`, tokenConfig(token));

export const updateClientUserOperatorsAction = (reqBody, token) =>
	axios.put(`${adminRoot}/controller/client_user_operator`, reqBody, tokenConfig(token));

export const assignClientOperatorAction = (reqBody, token) =>
	axios.put(`${adminRoot}/operator/assign_client`, reqBody, tokenConfig(token));

export const addDistributorAction = (reqBody, token) =>
	axios.post(`${adminRoot}/distributor/create`, reqBody, tokenConfig(token));

export const fetchRhbDuitNowAction = (reqBody, token) => {
	return axios.post(`${adminRoot}/rhbDuitNow`, reqBody, tokenConfig(token));
};

// Annual Scheduler Management API
export const getSchedulerStatusAction = (token) =>
	axios.get(`${adminRoot}/scheduler/status`, tokenConfig(token));

export const runDistributorSchedulerAction = (params, token) =>
	axios.post(`${adminRoot}/scheduler/distributor`, params, tokenConfig(token));

export const runMonthlySchedulerAction = (params, token) =>
	axios.post(`${adminRoot}/scheduler/monthly`, params, tokenConfig(token));

export const runYearlySchedulerAction = (params, token) =>
	axios.post(`${adminRoot}/scheduler/yearly`, params, tokenConfig(token));

export const runDailySchedulerAction = (params, token) =>
	axios.post(`${adminRoot}/scheduler/daily`, params, tokenConfig(token));

export const runTerminalTTSSchedulerAction = (params, token) =>
	axios.post(`${adminRoot}/scheduler/terminal-tts`, params, tokenConfig(token));

export const runTerminalCashlessSchedulerAction = (params, token) =>
	axios.post(`${adminRoot}/scheduler/terminal-cashless`, params, tokenConfig(token));

export const runTerminalCashlessThailandSchedulerAction = (params, token) =>
	axios.post(`${adminRoot}/scheduler/terminal-cashless-thailand`, params, tokenConfig(token));

// ********************************* Utility actions *********************************
// api/utility/v1/reset_volume
const utilityRoot = localhost ? '/api/utility/v1' : `${urlPicker}/api/utility/v1`;

export const getAllGasSensorsAction = (operatorId, outletSingleId, token) =>
	axios.get(`${utilityRoot}/fetch_currentdata?operatorId=${operatorId}&outletId=${outletSingleId}`, tokenConfig(token));

export const getAllChemicalSensorsAction = (operatorId, outletSingleId, token) =>
	axios.get(`${utilityRoot}/fetch_currentdata2?operatorId=${operatorId}&outletId=${outletSingleId}`, tokenConfig(token));

export const getRecordsOfUtilityAction = (reqBody, token) =>
	axios.post(`${utilityRoot}/fetch_records`, reqBody, tokenConfig(token));

export const resetVolumeAction = (reqBody, token) =>
	axios.put(`${utilityRoot}/reset_volume`, reqBody, tokenConfig(token));

export const refillVolumeAction = (reqBody, token) =>
	axios.put(`${utilityRoot}/refill_volume`, reqBody, tokenConfig(token));

export const fetchOutletsControllerAction = async (data, token) =>
	await axios.post(`${adminRoot}/controller/fetch`, data, tokenConfig(token));

export const fetchController = async (data, token) =>
	await axios.post(`${adminRoot}/controller/fetch`, data, tokenConfig(token));

export const fetchControllerv2 = async (data, token) =>
	await axios.post(`${adminRoot}/controller/fetchv2`, data, tokenConfig(token));

// get outlet pinger status
const outletOnlineRoot = localhost ? '/api/status/v1' : `${urlPicker}/api/status/v1`;
export const allOutletsOnlineStatusAction = (reqBody, token) => {
	const { outletId, startDate, endDate, operatorId } = reqBody;

	const queryParams =
		startDate && endDate
			? `outletId=${outletId}&startDate=${startDate}&endDate=${endDate}&operatorId=${operatorId}`
			: `outletId=${outletId}&operatorId=${operatorId}`;
	return axios.get(`${outletOnlineRoot}/pingerlog/fetch?${queryParams}`, tokenConfig(token));
};

// coinCollection Reducer
const coinCollectionRoot = localhost ? '/api/audit/v1/coin_collection' : `${urlPicker}/api/audit/v1/coin_collection`;
const billCollectionRoot = localhost ? '/api/audit/v1/bill_collection' : `${urlPicker}/api/audit/v1/bill_collection`;
export const machineCutoffStartAction = (data, token) =>
	axios.post(`${coinCollectionRoot}/start`, data, tokenConfig(token));

export const stockAdjustmentStartAction = (data, token) =>
	axios.post(`${coinCollectionRoot}/startStock`, data, tokenConfig(token));

export const machineCutoffAction = (data, token) =>
	axios.post(`${coinCollectionRoot}/cutoff`, data, tokenConfig(token));

export const machineCutoffSubmitAction = (data, token) =>
	axios.put(`${coinCollectionRoot}/submit`, data, tokenConfig(token));

export const machineCutoffEditAction = (data, token) =>
	axios.put(`${coinCollectionRoot}/edit`, data, tokenConfig(token));

export const machineCutoffBillSubmitAction = (data, token) =>
	axios.put(`${billCollectionRoot}/submit`, data, tokenConfig(token));

export const machineCutoffBillSubmitActionv2 = (data, token) =>
	axios.put(`${billCollectionRoot}/submitv2`, data, tokenConfig(token));

export const recalculateCoinCollectionAction = (coinCollectionId, token) =>
	axios.post(`${coinCollectionRoot}/recalculate/${coinCollectionId}`, {}, tokenConfig(token));

export const coinCollectionSubmitAction = (data, token) =>
	axios.put(`${coinCollectionRoot}/complete`, data, tokenConfig(token));

export const coinCollectionSubmitActionv2 = (data, token) =>
	axios.put(`${coinCollectionRoot}/completev2`, data, tokenConfig(token));

export const coinCollectionSubmitActionv3 = (data, token) =>
	axios.put(`${coinCollectionRoot}/completev3`, data, tokenConfig(token));

export const coinCollectionReceiptAction = (data, token) =>
	axios.post(`${coinCollectionRoot}/receipt`, data, tokenConfig(token));

export const machineCutoffListAction = (operatorId, token) =>
	axios.get(`${coinCollectionRoot}/dashboard?operatorId=${operatorId}`, tokenConfig(token));

export const machineCutoffListActionv2 = (dataBody, token) => {
	const { operatorId, startDate, endDate, outlets } = dataBody || {};

	const body = {
		outlets: outlets || [],
		startDate,
		endDate,
	};
	if (operatorId && operatorId.length) {
		body.operatorId = operatorId;
	}

	return axios.post(`${coinCollectionRoot}/dashboardv2`, body, tokenConfig(token));
};

export const billInvoiceSaveAction = async (formData, token) => {
	return await axios.put(`${billCollectionRoot}/invoice`, formData, tokenConfig(token));
};

export const getMachineCutoffHistoryAction = (data, token) =>
	axios.get(
		`${coinCollectionRoot}/cutoff/details?coinCollectionId=${data.coinCollectionId}&operatorId=${data.operatorId}`,
		tokenConfig(token)
	);

export const getCutoffStatusAction = (data, token) =>
	axios.get(
		`${coinCollectionRoot}/cutoff/status?id=${data.id}&outletId=${data.outletId}&operatorId=${data.operatorId}`,
		tokenConfig(token)
	);

export const getPreviousCutoffAction = (data, token) =>
	axios.post(
		`${coinCollectionRoot}/cutoff/previousInformation?id=${data.id}&outletId=${data.outletId}&operatorId=${data.operatorId}`,
		{ previousCutoffId: data.previousCutoffId }, // Send previousCutoffId in the body
		tokenConfig(token)
	);


//requestEndpoints.js
// report coin collection
export const getCoinCollectionByOutletAction = (reqBody, token) =>
	axios.post(`${coinCollectionRoot}/report/outlet`, reqBody, tokenConfig(token));

export const getCoinCollectionByMachineAction = (reqBody, token) =>
	axios.post(`${coinCollectionRoot}/report/machine`, reqBody, tokenConfig(token));

export const getBillCollectionReportAction = (reqBody, token) =>
	axios.post(`${billCollectionRoot}/report`, reqBody, tokenConfig(token));

const coinInventory = localhost ? '/api/inventory/v1' : `${urlPicker}/api/inventory/v1`;

export const refillCoinInventoryAction = (reqBody, token) =>
	axios.put(`${coinInventory}/refill_coin`, reqBody, tokenConfig(token));

export const resetCoinInventoryAction = (reqBody, token) =>
	axios.put(`${coinInventory}/reset_coin`, reqBody, tokenConfig(token));

export const fetchInventoryStockRecordsAction = (reqBody, token) =>
	axios.post(`${coinInventory}/fetch_records`, reqBody, tokenConfig(token));

// 
export const getCoinCollectionAction = (outletId, token) =>
	axios.get(`${remoteRoot}/group/fetch?outletId=${outletId}`, tokenConfig(token));

export const addCoinCollectionAction = (newCoinGroup, token) =>
	axios.post(`${remoteRoot}/group/create`, newCoinGroup, tokenConfig(token));

export const assignCoinCollectionAction = (coinGroup, token) =>
	axios.put(`${remoteRoot}/group/assign`, coinGroup, tokenConfig(token));

export const editCoinCollectionAction = (updateData, token) =>
	axios.put(`${remoteRoot}/group/edit`, updateData, tokenConfig(token));

export const deleteCoinCollectionAction = (id) => {
	return axios.delete(`${remoteRoot}/delete`, {
		...tokenConfig(),
		data: { id },
	});
};

export const getChemicalTypesAction = (outletId, token) =>
	axios.get(`${coinCollectionRoot}/chemicaltypes?outletId=${outletId}`, tokenConfig(token));

export const getCostingTypesAction = (outletId, token) =>
	axios.get(`${coinCollectionRoot}/costingtypes?outletId=${outletId}`, tokenConfig(token));

// Bill Group endpoints
export const getBillGroupAction = (outletId, operatorId, token) =>
	axios.get(`${remoteRoot}/group/bill/fetch?outletId=${outletId}&operatorId=${operatorId}`, tokenConfig(token));

export const addBillGroupAction = (newBillGroup, token) =>
	axios.post(`${remoteRoot}/group/bill/create`, newBillGroup, tokenConfig(token));

export const assignBillGroupAction = (billGroup, token) =>
	axios.put(`${remoteRoot}/group/bill/assign`, billGroup, tokenConfig(token));

export const editBillGroupAction = (updateData, token) =>
	axios.put(`${remoteRoot}/group/bill/edit`, updateData, tokenConfig(token));

// requestEndpoints.js
// ********************************* Chemical Input Stock and Chemical Stock Page  *********************************

const chemicalRoot = localhost ? '/api/inventorystock/v1' : `${urlPicker}/api/inventorystock/v1`;

export const fetchChemicalOutletListAction = ({ outletId, token }) =>
	axios.get(`${chemicalRoot}/set/type/fetch?outletId=${outletId}`, tokenConfig(token));

export const ManageChemicalsAction = (reqBody, token) =>
	axios.post(`${chemicalRoot}/stock/manage`, reqBody, tokenConfig(token));

export const fetchStockLogsAction = ({ outletId, token }) =>
	axios.get(`${chemicalRoot}/stock/logs/fetch?outletId=${outletId}`, tokenConfig(token));

export const fetchStockLogsAction2 = (reqBody, token) => {
	const { outletId, date,asOfDate, ...body } = reqBody || {};
	const params = {};
	if (outletId && outletId !== 'all') params.outletId = outletId;
	if (date) params.date = date;
	if (asOfDate) { params.asOfDate = asOfDate;}
	return axios.post(`${chemicalRoot}/stock/logs/fetch2`, body, { ...tokenConfig(token), params });
}

// requestEndpoints.js
// ********************************* Chemical Stock Setting Page *********************************

const chemicalTypeRoot = localhost ? '/api/chemical/v1/type' : `${urlPicker}/api/chemical/v1/type`;

export const getChemicalTypeAction = (operatorId, token) =>
	axios.get(`${chemicalTypeRoot}/fetch?operatorId=${operatorId}`, tokenConfig(token));

export const addChemicalTypeAction = (newChemicalType, token) => axios.post(`${chemicalTypeRoot}/add`, newChemicalType, tokenConfig(token));

export const assignChemicalTypeAction = (newChemicalType, token) => axios.put(`${chemicalTypeRoot}/assign`, newChemicalType, tokenConfig(token));

export const editChemicalTypeAction = (updateData, token) => axios.put(`${chemicalTypeRoot}/edit`, updateData, tokenConfig(token));

export const deleteChemicalTypeAction = (resData, token) => {
	return axios.delete(`${chemicalTypeRoot}/delete`, {
		...tokenConfig(token),
		data: resData,
	});
};

const costingTypeRoot = localhost ? '/api/costing/v1/type' : `${urlPicker}/api/costing/v1/type`;

export const getCostingTypeAction = (operatorId, token) =>
	axios.get(`${costingTypeRoot}/fetch/costing?operatorId=${operatorId}`, tokenConfig(token));

export const addCostingTypeAction = (newCostingType, token) => axios.post(`${costingTypeRoot}/add`, newCostingType, tokenConfig(token));

export const assignCostingTypeAction = (newCostingType, token) => axios.put(`${costingTypeRoot}/assign`, newCostingType, tokenConfig(token));

export const editCostingTypeAction = (updateData, token) => axios.put(`${costingTypeRoot}/edit`, updateData, tokenConfig(token));

export const deleteCostingTypeAction = (resData, token) => {
	return axios.delete(`${costingTypeRoot}/delete`, {
		...tokenConfig(token),
		data: resData,
	});
};

export const fetchCostingOutletListAction = ({ outletId, token }) =>
	axios.get(`${costingTypeRoot}/fetch/cost?outletId=${outletId}`, tokenConfig(token));

export const ManageCostingAction = (reqBody, token) =>
	axios.post(`${costingTypeRoot}/stock/manage`, reqBody, tokenConfig(token));


const salesTypeRoot = localhost ? '/api/sales/v1/type' : `${urlPicker}/api/sales/v1/type`;

export const getSalesTypeAction = (operatorId, token) =>
	axios.get(`${salesTypeRoot}/fetch/sales?operatorId=${operatorId}`, tokenConfig(token));

export const addSalesTypeAction = (newSalesType, token) => axios.post(`${salesTypeRoot}/add`, newSalesType, tokenConfig(token));

export const assignSalesTypeAction = (newSalesType, token) => axios.put(`${salesTypeRoot}/assign`, newSalesType, tokenConfig(token));

export const editSalesTypeAction = (updateData, token) => axios.put(`${salesTypeRoot}/edit`, updateData, tokenConfig(token));

export const deleteSalesTypeAction = (resData, token) => {
	return axios.delete(`${salesTypeRoot}/delete`, {
		...tokenConfig(token),
		data: resData,
	});
};

export const fetchSalesOutletListAction = ({ outletId, token }) =>
	axios.get(`${salesTypeRoot}/fetch/sales2?outletId=${outletId}`, tokenConfig(token));

export const ManageSalesAction = (reqBody, token) =>
	axios.post(`${salesTypeRoot}/stock/manage/sales`, reqBody, tokenConfig(token));


export const getCostingItemTypesAction = (operatorId, token) => axios.get(`${reportRoot}/costing/item?operatorId=${operatorId}`, tokenConfig(token));

// ***************************** Machine Efficiency Details ***********************************
const machineDetailsRoot = localhost ? '/api/machine/v1' : `${urlPicker}/api/machine/v1`;


export const fetchContactAction = (token, operatorId) =>
	axios.get(`${machineDetailsRoot}/fetchContact`, { ...tokenConfig(token), params: operatorId ? { operatorId } : {} });


export const fetchMachineDetailsAction = (operatorId, filterMonth, filterYear, paginationNumber, token) =>
	axios.post(`${machineDetailsRoot}/details/fetch`, { operatorId, filterMonth, filterYear, paginationNumber }, tokenConfig(token));


// PROFIT & LOSS BACKEND ENDPOINTS
const profitLossRoot = localhost ? '/api/profitloss/v1/type' : `${urlPicker}/api/profitloss/v1/type`;

export const getProfitLossAction = (operatorId, outletId, year, month, token) =>
	axios.get(
		`${profitLossRoot}/fetch/profitloss?operatorId=${operatorId}&outletId=${outletId}&year=${year}&month=${month}`,
		tokenConfig(token)
	);

export const addProfitLossAction = (newProfitLoss, token) =>
	axios.post(`${profitLossRoot}/add`, newProfitLoss, tokenConfig(token));

export const editProfitLossAction = (updateData, token) =>
	axios.put(`${profitLossRoot}/edit`, updateData, tokenConfig(token));

export const deleteProfitLossAction = (resData, token) =>
	axios.delete(`${profitLossRoot}/delete`, { ...tokenConfig(token), data: resData });

// ********************************* offline logs *********************************
// offlineLogReducer actions
const offlineLogRoot = localhost ? '/api/offlinelog/v1' : `${urlPicker}/api/offlinelog/v1`;

export const fetchOfflineLogsAction = (reqBody, token) =>
	axios.post(`${offlineLogRoot}/offline/log`, reqBody, tokenConfig(token));

export const allMachinesOfflineLogAction = (operatorId, outletId, token) =>
	axios.get(`${offlineLogRoot}/fetch/offlinelog?&operatorId=${operatorId}&outletId=${outletId}`, tokenConfig(token));

// ********************************* outlet additional info *********************************
export const getOutletAdditionalInfoAction = (outletId, token) =>
	axios.get(`${outletRoot}/additional-info/${outletId}`, tokenConfig(token));

export const addOutletAdditionalInfoAction = (reqBody, token) =>
	axios.post(`${outletRoot}/additional-info/create`, reqBody, tokenConfig(token));

export const updateOutletAdditionalInfoAction = (reqBody, token) =>
	axios.put(`${outletRoot}/additional-info/update`, reqBody, tokenConfig(token));
